import React from "react";
import { PageHeaderProps } from "./types";

const PageHeader: React.FC<PageHeaderProps> = ({ children }) => {
  return (
    <>
      <div className=" px-3 pt-2 xl:px-6 xl:pt-4 pb-4 ">
        {children}
      </div>
    </>
  );
};

export default React.memo(PageHeader);
